var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitySummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8572 23.8095H1.19049V2.14282",
    stroke: "#2280FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4265 5.58859L19.4773 10.6394M14.4265 5.58859L6.00856 14.0065L6.00403 19.0528L11.0593 19.0573L19.4773 10.6394M14.4265 5.58859L16.1101 3.90501C17.0399 2.97519 18.5474 2.97519 19.4773 3.90501L21.1609 5.58859C22.0907 6.51841 22.0907 8.02595 21.1609 8.95577L19.4773 10.6394",
    stroke: "#2280FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySummary);
export default __webpack_public_path__ + "static/media/activity-summary.9bd4c4b6c367211c247f5f3b30b4a46f.svg";
export { ForwardRef as ReactComponent };